const pages = {
  // ---- News listing ----
  "news.title": "L+TV Newsroom",
  "news.subtitle": "Latest news from Cameroon and beyond",
  "news.searchPlaceholder": "Search news...",
  "news.latestStories": "Latest Stories",
  "news.readFullStory": "Read Full Story",
  "news.noArticles": "No articles found matching your criteria.",
  "news.cat.all": "All",
  "news.cat.breaking": "Breaking News",
  "news.cat.local": "Local News",
  "news.cat.national": "National News",
  "news.cat.international": "International News",
  "news.cat.politics": "Politics",
  "news.cat.business": "Business",
  "news.cat.technology": "Technology",
  "news.cat.society": "Society",
  "news.cat.religion": "Religion",
  "news.cat.culture": "Culture",
  "news.cat.sports": "Sports",
  "news.cat.entertainment": "Entertainment",
  "news.cat.lifestyle": "Lifestyle",

  // ---- News article ----
  "article.notFound": "Article Not Found",
  "article.notFoundDesc": "The article you are looking for does not exist.",
  "article.backToNews": "Back to News",
  "article.news": "News",
  "article.share": "Share this article",
  "article.related": "Related Stories",
  "article.stayTuned":
    "L+TV TÉLÉVISION continues to bring you the latest updates and in-depth coverage on this story. Stay tuned to our live broadcasts, news programs, and digital platforms for real-time information as events unfold. Our commitment to professional journalism ensures that every story is reported with accuracy, integrity, and the highest editorial standards.",
  "article.moreStories":
    "For more stories like this, visit our Newsroom or follow L+TV on our social media channels. We value your feedback and encourage viewers to share their perspectives on the stories that matter most to our community.",

  // ---- Programs ----
  "programs.title": "L+TV Programs",
  "programs.subtitle": "Discover our television programming lineup",
  "program.notFound": "Program Not Found",
  "program.backToPrograms": "Back to Programs",
  "program.relatedVideos": "Related Videos",
  "program.programDetails": "Program Details",
  "program.category": "Category",
  "program.department": "Department",
  "program.presenter": "Presenter",
  "program.broadcastDays": "Broadcast Days",
  "program.time": "Time",
  "program.duration": "Duration",
  "program.views": "views",

  // ---- Schedule ----
  "schedule.title": "TV Schedule",
  "schedule.subtitle": "Electronic Program Guide for L+TV TÉLÉVISION",
  "schedule.thisWeek": "This Week",
  "schedule.onNow": "ON NOW",
  "schedule.live": "LIVE",
  "schedule.comingSoon": "Schedule for {tab} will be available soon.",
  "schedule.today": "Today",
  "schedule.tomorrow": "Tomorrow",

  // ---- About ----
  "about.title": "About L+TV",
  "about.subtitle": "The Television That Connects You — Edea, Cameroon",
  "about.whoWeAre": "Who We Are",
  "about.whoP1":
    "L+TV TÉLÉVISION is a television and digital media channel based in Edea, Cameroon. We are dedicated to delivering professional, informative, and impactful content that connects communities across Cameroon and the broader African diaspora.",
  "about.whoP2":
    "From breaking news and live television to cultural programming, sports coverage, and community-focused content, L+TV brings viewers closer to the stories that matter most.",
  "about.whoP3":
    "Our team of experienced journalists, producers, and broadcast professionals work tirelessly to ensure that every program meets the highest standards of quality and editorial integrity.",
  "about.ourVision": "Our Vision",
  "about.visionQuote": "To make L+TV a local, professional, and impactful channel.",
  "about.ourMission": "Our Mission",
  "about.missionText":
    "L+TV TÉLÉVISION is committed to professional broadcasting that delivers informative content, strengthens community connections, and produces impactful programming. We believe in the power of television to educate, inspire, and unite people across Cameroon and beyond. Our mission is to serve as a trusted source of news, entertainment, and cultural content that reflects the values, aspirations, and diversity of our audience.",
  "about.ourValues": "Our Values",
  "about.ourDepartments": "Our Departments",
  "about.value.excellence": "Excellence",
  "about.value.excellenceDesc":
    "We strive for excellence in every broadcast, program, and piece of content we produce.",
  "about.value.professionalism": "Professionalism",
  "about.value.professionalismDesc":
    "Our team operates with the highest standards of professional conduct and broadcast quality.",
  "about.value.discipline": "Discipline",
  "about.value.disciplineDesc":
    "We maintain strict editorial discipline, meeting deadlines and delivering consistent quality.",
  "about.value.integrity": "Integrity",
  "about.value.integrityDesc":
    "Truth and integrity are at the heart of our journalism and broadcasting standards.",
  "about.value.community": "Community",
  "about.value.communityDesc":
    "We are committed to serving and connecting the communities of Cameroon.",
  "about.value.creativity": "Creativity",
  "about.value.creativityDesc":
    "We embrace creative storytelling and innovative approaches to television production.",
  "about.value.responsible": "Responsible Broadcasting",
  "about.value.responsibleDesc":
    "We broadcast with responsibility, respect, and consideration for our diverse audience.",
  "about.dept.news": "News Department",
  "about.dept.newsDesc":
    "Delivering accurate, timely, and in-depth news coverage across local, national, and international stories.",
  "about.dept.entertainment": "Entertainment & Culture Department",
  "about.dept.entertainmentDesc":
    "Producing engaging entertainment, music, cultural programming, and youth content that reflects the diversity of Cameroon.",
  "about.dept.technical": "Technical & Broadcasting Department",
  "about.dept.technicalDesc":
    "Managing the technical infrastructure, live broadcasts, and studio operations that power L+TV's programming.",
  "about.dept.photo": "Photo Studio",
  "about.dept.photoDesc":
    "Professional photography services for portraits, events, commercial shoots, and creative projects.",
  "about.dept.production": "Production Company",
  "about.dept.productionDesc":
    "Full-service video and television production for clients, partners, and internal programming needs.",

  // ---- Contact ----
  "contact.title": "Contact L+TV",
  "contact.subtitle": "We would love to hear from you. Get in touch with L+TV TÉLÉVISION.",
  "contact.info": "Contact Information",
  "contact.email": "Email",
  "contact.phone": "Phone",
  "contact.location": "Location",
  "contact.follow": "Follow L+TV",
  "contact.edea": "Edea, Cameroon",
  "contact.mapNote": "Map integration available",
  "contact.sendTitle": "Send Us a Message",
  "contact.sendDesc": "Fill out the form below and we will get back to you as soon as possible.",
  "contact.messageSent": "Message Sent!",
  "contact.messageSentDesc": "Thank you for contacting L+TV. We will respond to your inquiry shortly.",
  "contact.fullName": "Full Name",
  "contact.emailAddress": "Email Address",
  "contact.phoneNumber": "Phone Number",
  "contact.subject": "Subject",
  "contact.department": "Department",
  "contact.message": "Message",
  "contact.yourName": "Your name",
  "contact.yourEmail": "your@email.com",
  "contact.subjectPlaceholder": "Subject of your message",
  "contact.messagePlaceholder": "Your message...",
  "contact.maxChars": "Maximum 500 characters",
  "contact.send": "Send Message",
  "contact.required": "Please fill in all required fields.",
  "contact.invalidEmail": "Please enter a valid email address.",
  "contact.error": "Something went wrong sending your message. Please try again.",
  "contact.dept.general": "General Enquiries",
  "contact.dept.newsroom": "Newsroom",
  "contact.dept.advertising": "Advertising",
  "contact.dept.partnerships": "Partnerships",
  "contact.dept.technical": "Technical Support",
  "contact.dept.careers": "Careers",
  "contact.dept.programs": "Programs",

  // ---- Adverts ----
  "adverts.title": "Announcements & Advertisements",
  "adverts.subtitle": "Sponsored campaigns, special announcements, and featured adverts from L+TV and our partners.",
  "adverts.noAdverts": "No adverts available at the moment. Please check back soon.",
  "adverts.active": "Active",
  "adverts.learnMore": "Learn more",

  // ---- Entertainment ----
  "entertainment.title": "Entertainment & Culture",
  "entertainment.subtitle": "Talk shows, music, youth, culture, and community stories",
  "entertainment.featuredPrograms": "Featured Programs",
  "entertainment.latestVideos": "Latest Videos",
  "entertainment.culturalStories": "Cultural Stories",

  // ---- Sports ----
  "sports.title": "L+TV Sports",
  "sports.subtitle": "Sports news, match reports, interviews, and local coverage",
  "sports.programs": "Sports Programs",
  "sports.news": "Sports News",
  "sports.videos": "Sports Videos",
  "sports.newsComingSoon": "Sports news articles coming soon.",
  "sports.videosComingSoon": "Sports videos coming soon.",

  // ---- Religion ----
  "religion.title": "Religion & Community",
  "religion.subtitle": "Biblical teaching, religious discussions, and community events",
  "religion.intro":
    "L+TV TÉLÉVISION is committed to supporting the spiritual and community life of our viewers. Our religion and community programs bring biblical teaching, faith-based discussions, and coverage of community events that strengthen bonds across Cameroon.",
  "religion.programs": "Programs",

  // ---- Gallery ----
  "gallery.title": "L+TV Gallery",
  "gallery.subtitle": "Photos from our programs, events, studio and community",
  "gallery.loading": "Loading gallery…",
  "gallery.noAlbums": "No photo albums published yet.",
  "gallery.albums": "albums",
  "gallery.photos": "photos",
  "gallery.close": "Close",
  "gallery.noPhotos": "No photos in this album yet.",

  // ---- Production ----
  "production.title": "L+TV Production Company",
  "production.subtitle": "Professional television and video production services",
  "production.intro":
    "L+TV Production Company brings professional broadcast-quality production services to individuals, businesses, organizations, and institutions. With state-of-the-art equipment and an experienced production team, we deliver content that meets the highest standards of television and digital media.",
  "production.servicesTitle": "Our Production Services",
  "production.ctaTitle": "Interested in Production Services?",
  "production.ctaDesc": "Contact L+TV to discuss your production needs and get a quote.",
  "production.getInTouch": "Get in Touch",
  "production.svc.tv.title": "Television Production",
  "production.svc.tv.desc": "Full-scale television production for broadcast and digital platforms, including live events, studio shows, and remote shoots.",
  "production.svc.video.title": "Video Production",
  "production.svc.video.desc": "High-quality video production for commercials, documentaries, corporate videos, and promotional content.",
  "production.svc.interviews.title": "Interviews",
  "production.svc.interviews.desc": "Professional interview production with experienced producers, directors, and technical crew for broadcast-ready content.",
  "production.svc.event.title": "Event Coverage",
  "production.svc.event.desc": "Complete event coverage including multi-camera setups, live streaming, and post-production for conferences, ceremonies, and cultural events.",
  "production.svc.commercial.title": "Commercial Production",
  "production.svc.commercial.desc": "Creative commercial and advertising production services for brands and businesses seeking impactful visual storytelling.",
  "production.svc.documentary.title": "Documentary Production",
  "production.svc.documentary.desc": "In-depth documentary production telling compelling stories about people, communities, and important issues in Cameroon.",
  "production.svc.studio.title": "Studio Production",
  "production.svc.studio.desc": "Professional studio production services utilizing L+TV's broadcast facilities with modern equipment and experienced crew.",

  // ---- Photo Studio ----
  "studio.title": "L+TV Photo Studio",
  "studio.subtitle": "Professional photography services in Edea, Cameroon",
  "studio.intro":
    "L+TV Photo Studio offers professional photography services for individuals, families, businesses, and events. Our studio is equipped with professional lighting, backdrops, and camera equipment to deliver stunning visual results.",
  "studio.servicesTitle": "Our Services",
  "studio.portfolio": "Portfolio",
  "studio.ctaTitle": "Book a Photo Session",
  "studio.ctaDesc": "Contact L+TV to schedule your professional photography session.",
  "studio.contactUs": "Contact Us",
  "studio.svc.portrait.title": "Portrait Photography",
  "studio.svc.portrait.desc": "Professional headshots, family portraits, and individual sessions in our fully equipped studio.",
  "studio.svc.event.title": "Event Photography",
  "studio.svc.event.desc": "Complete coverage of weddings, ceremonies, corporate events, and community gatherings.",
  "studio.svc.studio.title": "Studio Photography",
  "studio.svc.studio.desc": "High-quality studio sessions with professional lighting, backdrops, and equipment.",
  "studio.svc.commercial.title": "Commercial Photography",
  "studio.svc.commercial.desc": "Product photography, promotional images, and brand visual content for businesses.",

  // ---- Careers ----
  "careers.title": "Careers at L+TV",
  "careers.subtitle": "Join the team at L+TV TÉLÉVISION",
  "careers.intro":
    "L+TV TÉLÉVISION is always looking for talented, passionate individuals to join our team. If you are dedicated to professional broadcasting, quality journalism, and community impact, we want to hear from you.",
  "careers.openPositions": "Open Positions",
  "careers.requirements": "Requirements",
  "careers.responsibilities": "Responsibilities",
  "careers.deadline": "Deadline",
  "careers.applyNow": "Apply Now",
  "careers.submitTitle": "Submit Your Application",
  "careers.submitDesc": "Apply for a position at L+TV by completing the form below.",
  "careers.submittedTitle": "Application Submitted!",
  "careers.submittedDesc": "Thank you for your interest. Our HR team will review your application and contact you.",
  "careers.fullName": "Full Name",
  "careers.email": "Email",
  "careers.phone": "Phone",
  "careers.position": "Position",
  "careers.selectPosition": "Select a position",
  "careers.other": "Other / General Application",
  "careers.coverLetter": "Cover Letter",
  "careers.coverPlaceholder": "Why do you want to join L+TV?",
  "careers.cvUpload": "CV / Document Upload",
  "careers.cvDrag": "Drag and drop your CV or click to browse",
  "careers.cvNote": "PDF, DOC, DOCX up to 5MB",
  "careers.submitApp": "Submit Application",

  // ---- Partners ----
  "partners.title": "Partners & Collaboration",
  "partners.subtitle": "Working with organizations that support media and community initiatives",
  "partners.intro":
    "L+TV works with organizations and partners whose collaboration supports media, community, and social-impact initiatives. We believe in the power of partnerships to create meaningful content and drive positive change across Cameroon.",
  "partners.ctaTitle": "Partner With L+TV",
  "partners.ctaDesc":
    "If your organization shares our commitment to community, media, and social impact, we would love to explore partnership opportunities. Contact us to discuss how we can collaborate.",
  "partners.getInTouch": "Get in Touch",

  // ---- Legal ----
  "legal.privacy.title": "Privacy Policy",
  "legal.privacy.sec1": "1. Introduction",
  "legal.privacy.sec1p": "L+TV TÉLÉVISION respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our website and services.",
  "legal.privacy.sec2": "2. Information We Collect",
  "legal.privacy.sec2p": "We may collect personal information such as your name, email address, phone number, and other details you provide when contacting us, subscribing to newsletters, or applying for positions.",
  "legal.privacy.sec3": "3. How We Use Your Information",
  "legal.privacy.sec3p": "We use your information to provide and improve our services, respond to inquiries, send newsletters, process applications, and comply with legal obligations.",
  "legal.privacy.sec4": "4. Data Security",
  "legal.privacy.sec4p": "We implement appropriate security measures to protect your personal information against unauthorized access, alteration, or destruction.",
  "legal.privacy.sec5": "5. Contact Us",
  "legal.privacy.sec5p": "If you have any questions about this Privacy Policy, please contact us at L+TV TÉLÉVISION, P.O. Box: EDEA - Cameroon.",

  "legal.terms.title": "Terms & Conditions",
  "legal.terms.sec1": "1. Acceptance of Terms",
  "legal.terms.sec1p": "By accessing and using the L+TV TÉLÉVISION website, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our website.",
  "legal.terms.sec2": "2. Use of Content",
  "legal.terms.sec2p": "All content on this website, including text, images, videos, and logos, is the property of L+TV TÉLÉVISION and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or modify any content without prior written permission.",
  "legal.terms.sec3": "3. User Conduct",
  "legal.terms.sec3p": "Users agree to use the website in a lawful manner and not to engage in any activity that may harm the website, its users, or L+TV TÉLÉVISION.",
  "legal.terms.sec4": "4. Limitation of Liability",
  "legal.terms.sec4p": "L+TV TÉLÉVISION is not liable for any damages arising from the use or inability to use this website or its content.",
  "legal.terms.sec5": "5. Governing Law",
  "legal.terms.sec5p": "These terms are governed by the laws of the Republic of Cameroon.",

  "legal.cookies.title": "Cookie Policy",
  "legal.cookies.sec1": "1. What Are Cookies",
  "legal.cookies.sec1p": "Cookies are small text files that are placed on your device when you visit a website. They help the website recognize your device and store information about your preferences or past actions.",
  "legal.cookies.sec2": "2. How We Use Cookies",
  "legal.cookies.sec2p": "L+TV TÉLÉVISION uses cookies to improve your browsing experience, analyze website traffic, and understand how visitors interact with our website. We may use both session and persistent cookies.",
  "legal.cookies.sec3": "3. Types of Cookies We Use",
  "legal.cookies.sec3p": "Essential cookies are necessary for the website to function properly. Analytical cookies help us understand how visitors interact with our website. Functional cookies enable enhanced functionality and personalization.",
  "legal.cookies.sec4": "4. Managing Cookies",
  "legal.cookies.sec4p": "You can manage or disable cookies through your browser settings. Please note that disabling certain cookies may affect the functionality of this website.",
  "legal.cookies.sec5": "5. Contact",
  "legal.cookies.sec5p": "If you have questions about our Cookie Policy, please contact us at L+TV TÉLÉVISION, P.O. Box: EDEA - Cameroon.",

  "legal.disclaimer.title": "Disclaimer",
  "legal.disclaimer.sec1": "1. Information Accuracy",
  "legal.disclaimer.sec1p": "L+TV TÉLÉVISION makes every effort to ensure that the information on this website is accurate and up-to-date. However, we do not guarantee the completeness, accuracy, or reliability of any information provided.",
  "legal.disclaimer.sec2": "2. External Links",
  "legal.disclaimer.sec2p": "This website may contain links to external websites. L+TV TÉLÉVISION is not responsible for the content, accuracy, or practices of any linked websites.",
  "legal.disclaimer.sec3": "3. Content Usage",
  "legal.disclaimer.sec3p": "The content on this website is provided for informational purposes only. It should not be construed as professional advice. Users should verify information independently before making decisions based on website content.",
  "legal.disclaimer.sec4": "4. Changes to Content",
  "legal.disclaimer.sec4p": "L+TV TÉLÉVISION reserves the right to modify, update, or remove content from this website at any time without prior notice.",
  "legal.disclaimer.sec5": "5. Contact",
  "legal.disclaimer.sec5p": "For questions regarding this disclaimer, please contact L+TV TÉLÉVISION, P.O. Box: EDEA - Cameroon.",

  // ---- Videos listing ----
  "videos.title": "L+TV Video Center",
  "videos.subtitle": "Watch news, programs, reports, and exclusive content",
  "videos.searchPlaceholder": "Search videos...",
  "videos.noResults": "No videos found matching your criteria.",
  "videos.cat.all": "All",
  "videos.cat.news": "News",
  "videos.cat.interviews": "Interviews",
  "videos.cat.reports": "Reports",
  "videos.cat.talkshows": "Talk Shows",
  "videos.cat.entertainment": "Entertainment",
  "videos.cat.culture": "Culture",
  "videos.cat.religion": "Religion",
  "videos.cat.children": "Children's Programs",
  "videos.cat.sports": "Sports",
  "videos.cat.documentaries": "Documentaries",
  "videos.cat.short": "Short Videos",
  "videos.cat.behind": "Behind the Scenes",

  // ---- Advertise ----
  "advertise.title": "Advertise With L+TV",
  "advertise.subtitle": "Reach your audience through L+TV's television and digital platforms",
  "advertise.intro":
    "L+TV TÉLÉVISION offers a range of advertising and promotional opportunities for businesses, organizations, and brands looking to reach audiences across Cameroon and beyond. Whether you are looking for television commercials, digital placements, or event partnerships, we can help you craft a campaign that delivers results.",
  "advertise.servicesTitle": "Advertising Services",
  "advertise.svc.tv.title": "Television Advertising",
  "advertise.svc.tv.desc": "Reach thousands of viewers across Cameroon with professionally produced television commercials aired on L+TV.",
  "advertise.svc.web.title": "Website Advertising",
  "advertise.svc.web.desc": "Display your brand on L+TV's digital platform with banner placements, sponsored content, and featured listings.",
  "advertise.svc.program.title": "Sponsored Programs",
  "advertise.svc.program.desc": "Sponsor a specific program or series and align your brand with high-quality content that resonates with your target audience.",
  "advertise.svc.content.title": "Sponsored Content",
  "advertise.svc.content.desc": "Partner with L+TV to create branded content that informs and engages viewers while promoting your products or services.",
  "advertise.svc.video.title": "Video Promotion",
  "advertise.svc.video.desc": "Have your promotional videos, product showcases, or brand stories featured on L+TV's video center and social channels.",
  "advertise.svc.social.title": "Social Media Promotion",
  "advertise.svc.social.desc": "Leverage L+TV's social media presence to amplify your brand message across Facebook, YouTube, TikTok, Instagram, and more.",
  "advertise.svc.event.title": "Event Partnerships",
  "advertise.svc.event.desc": "Partner with L+TV for live event coverage, co-branded productions, and special broadcast opportunities.",
  "advertise.formTitle": "Advertising Enquiry",
  "advertise.formDesc": "Tell us about your advertising needs and we will get back to you with options and availability.",
  "advertise.receivedTitle": "Enquiry Received!",
  "advertise.receivedDesc": "Our advertising team will contact you shortly with options and pricing.",
  "advertise.fullName": "Full Name",
  "advertise.email": "Email",
  "advertise.company": "Company / Organization",
  "advertise.phone": "Phone",
  "advertise.service": "Interested Service",
  "advertise.selectService": "Select a service",
  "advertise.message": "Message",
  "advertise.messagePlaceholder": "Tell us about your campaign needs...",
  "advertise.submit": "Submit Enquiry",

  // ---- Direct ----
  "direct.title": "L+TV Direct",
  "direct.subtitle": "Live digital campaigns, interactive content, and community engagement",
  "direct.intro":
    "L+TV Direct is a special digital campaign platform where we bring live broadcasts, community discussions, interviews, and special events directly to you. Participate, ask questions, and interact with presenters in real time.",
  "direct.tab.all": "All",
  "direct.tab.live": "Live",
  "direct.tab.upcoming": "Upcoming",
  "direct.tab.ended": "Ended",
  "direct.liveNow": "LIVE NOW",
  "direct.joinLive": "Join Live",
  "direct.noSessions": "No sessions found in this category.",

  // ---- Videos detail ----
  "video.notFound": "Video Not Found",
  "video.backToVideos": "Back to Videos",
  "video.relatedVideos": "Related Videos",
  "video.views": "views",
  "video.share": "Share",

  // ---- Live ----
  "live.liveTelevision": "Live Television",
  "live.title": "L+TV LIVE",
  "live.subtitle": "Watch L+TV TÉLÉVISION live from Edea, Cameroon",
  "live.offlineTitle": "L+TV is Currently Offline",
  "live.nextBroadcast": "Next Broadcast",
  "live.nowPlaying": "Now Playing",
  "live.upNext": "Up Next",
  "live.todaySchedule": "Today's Schedule",
  "live.fullSchedule": "Full Schedule",

  // ---- Search ----
  "search.placeholder": "Search news, programs, videos…",
  "search.noResults": "No results found.",
  "search.news": "News",
  "search.programs": "Programs",
  "search.videos": "Videos",
  "search.viewAll": "View all results",

  // ---- Shared ----
  "common.back": "Back",
  "common.readMore": "Read More",
  "common.viewAll": "View All",
};

export default pages;